export default __webpack_public_path__ + "img/groupama-homepage2.bec62494.svg";